import React from "react";

import { useInitializeAmplitudeAnalytics } from "./hooks";

export const AmplitudeAnalyticsProvider = React.memo(() => {
  useInitializeAmplitudeAnalytics();

  return null;
});
